export default __webpack_public_path__ + "media/images/fb_icon-ebc9707e3c075b409ba770a0faa2ca36.png";